import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PasswordConfirmComponent } from '../../components/password-confirm/password-confirm.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [PasswordConfirmComponent, FooterComponent, HeaderComponent],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss'
})
export class ChangePasswordComponent {
  public usr:any = '';
  constructor(private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.usr = this.route.snapshot.queryParamMap.get('usr');
  }

}
